// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--2-hg1";
export var footerNav = "footer-module--footer-nav--vohZU";
export var copyright = "footer-module--copyright--3yIxz";
export var linkArea = "footer-module--link-area--VOIRi";
export var linkCategory = "footer-module--link-category--30KYJ";
export var listHeader = "footer-module--list-header--2UQbO";
export var linkList = "footer-module--link-list--2KVo7";
export var link = "footer-module--link--3CZtx";
export var navLink = "footer-module--nav-link--3t7wr";